import { UseResendChangeEmailConfirmationReturnType } from './useResendChangeEmailConfirmation.decl';

import { SendConfirmationEmailMutation } from '@generated/SendConfirmationEmailMutation';
import { SEND_CONFIRMATION_EMAIL_MUTATION } from '@graphql/mutations/SendConfirmationEmailMutation';
import { useGraphMutationWithFeedback } from '@hooks/useMutation';
import noop from 'lodash-es/noop';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

/**
 * Hook to send a user's change confirmation email.
 * @returns an object holding a function responsible for sending a confirmation email, and its states
 */
export function useResendChangeEmailConfirmation(): UseResendChangeEmailConfirmationReturnType {
  const { t } = useTranslation();
  const { userId } = useParams();
  const [send, { loading }] = useGraphMutationWithFeedback<SendConfirmationEmailMutation>(
    SEND_CONFIRMATION_EMAIL_MUTATION,
    {
      type: 'snackbar',
    }
  );

  const handleSendEmail = () =>
    send(
      {
        variables: {
          userId: parseInt(userId),
          // Necessary as apollo-link-rest is not comfortable with POST
          // requests with an empty body
          bodyBuilder: noop,
        },
      },
      { successMessage: t('user_profile.confirmation_banner.email') }
    );

  return { loading, sendEmail: handleSendEmail };
}
